import { MessageState } from 'Modules/Communication/shared/models/Inbox'
import { messageStateToInboxSectionEnum } from 'Modules/Communication/shared/util/messageStateHelper'
import { SystemState } from './types'

export const getSmsMessages = (state: SystemState) =>
  state.communication?.smsMessages

export const getSmsSection = (state: SystemState) =>
  state.communication.smsMessages.filters.queryStatus

export const getSmsFilters = (state: SystemState) =>
  state.communication.smsMessages.filters

export const getSmsLabel = (state: SystemState) =>
  state.communication.smsMessages.filters.labelId

export const getSmsMessagesMarkedForActions = (state: SystemState) =>
  state.communication.smsMessages.marked
export const getSms = (state: SystemState) =>
  state.communication.smsMessages.sms

export const isSmsMarkedForAction = (id: string) => (state: SystemState) =>
  state.communication.smsMessages.marked.includes(id)

export const getCurrentSms = (state: SystemState) =>
  state.communication.smsMessages.sms.current

export const getSmsFromSmsMessagesById = (id: string) => (state: SystemState) =>
  getSmsMessages(state)?.data?.result.find((sms) => sms.id === id)

export const getSingleListSmsActionId = (state: SystemState) =>
  state.communication.smsMessages.singleListActionId

export const getCurrentSmsState = (currentId?: string) => (
  state: SystemState
) => {
  const email = getSms(state)
  if (!currentId) return null
  if (!email.current) return null

  const currentState = getSms(state).data.state || MessageState.Processed
  return messageStateToInboxSectionEnum(currentState)
}
